import React from 'react'
import styled from 'styled-components';

const Wrapper = styled.li`
  display: inline-block;
  width: 50px;
  height: 13px;
  border: 2px solid #CF0207;
  transform: skew(-30deg);
  margin: 0 10px;
  background-color: ${props => props.isSelected ? '#CF0207' : 'transparent' };
  cursor: pointer;
`;

const Indicator = ({ index, isSelected, onClick }) => (
  <Wrapper onClick={() => onClick(index)} isSelected={isSelected} />
);

export default Indicator;
